;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type {SerializedTextNode} from "@payloadcms/richtext-lexical";
import type {JSXConverters} from "@payloadcms/richtext-lexical/react";
import type React from "react";

const IS_BOLD = 1;
const IS_ITALIC = 2;
const IS_STRIKETHROUGH = 4;
const IS_UNDERLINE = 8;
const IS_CODE = 16;
const IS_SUBSCRIPT = 32;
const IS_SUPERSCRIPT = 64;

export const TextHTMLConverter: JSXConverters<SerializedTextNode> = {
	text: ({ node }) => {
		let text: React.ReactNode = node?.text;

		if (node.format & IS_BOLD) text = <strong>{text}</strong>;
		if (node.format & IS_ITALIC) text = <em>{text}</em>;
		if (node.format & IS_STRIKETHROUGH)
			text = <span style={{ textDecoration: "line-through" }}>{text}</span>;
		if (node.format & IS_UNDERLINE)
			text = <span style={{ textDecoration: "underline" }}>{text}</span>;
		if (node.format & IS_CODE) text = <code>{text}</code>;
		if (node.format & IS_SUBSCRIPT) text = <sub>{text}</sub>;
		if (node.format & IS_SUPERSCRIPT) text = <sup>{text}</sup>;

		if (node.$?.color === "text-red")
			text = <span style={{ color: "red" }}>{text}</span>;
		if (node.$?.color === "text-orange")
			text = <span style={{ color: "orange" }}>{text}</span>;
		if (node.$?.color === "text-yellow")
			text = <span style={{ color: "yellow" }}>{text}</span>;
		if (node.$?.color === "text-green")
			text = <span style={{ color: "green" }}>{text}</span>;
		if (node.$?.color === "text-blue")
			text = <span style={{ color: "blue" }}>{text}</span>;
		if (node.$?.color === "text-purple")
			text = <span style={{ color: "purple" }}>{text}</span>;
		if (node.$?.color === "text-pink")
			text = <span style={{ color: "pink" }}>{text}</span>;
		if (node.$?.color === "primary")
			text = <span style={{ color: "var(--color-primary)" }}>{text}</span>;
		if (node.$?.color === "secondary")
			text = (
				<span style={{ color: "var(--color-primary-light)" }}>{text}</span>
			);

		return text;
	},
	// heading: ({ converters, node }) => {
	// 	const childrenHTML =
	// 		node.children
	// 			?.map((childNode) => {
	// 				const converter = converters?.[childNode.type];
	// 				return typeof converter === "function"
	// 					? converter({
	// 							converters,
	// 							node: childNode,
	// 							parent: node,
	// 							childIndex: 0,
	// 							nodesToHTML: (args: {
	// 								converters?: HTMLConverters;
	// 								disableIndent?: boolean | string[];
	// 								disableTextAlign?: boolean | string[];
	// 								nodes: SerializedLexicalNode[];
	// 								parent?: SerializedLexicalNodeWithParent;
	// 							}): string[] => {
	// 								throw new Error("Function not implemented.");
	// 							},
	// 							providedCSSString: "",
	// 							providedStyleTag: "",
	// 						})
	// 					: "";
	// 			})
	// 			.join("") || "";
	//
	// 	const tag = node.tag || "h1";
	// 	// Add anchor ID only for h2 when table is true
	// 	if (table && node.tag === "h2") {
	// 		const textContent = node.children
	// 			?.filter((child) => child.type === "text")
	// 			.map((child) => (child as SerializedTextNode).text)
	// 			.join("");
	//
	// 		if (textContent) {
	// 			const anchorId = createAnchorId(textContent);
	// 			return `<${tag} id="${anchorId}">${childrenHTML}</${tag}>`;
	// 		}
	// 	}
	//
	// 	return `<${tag}>${childrenHTML}</${tag}>`;
	// },
};
